// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2V8Fm","name":"ConsentHeader_name__3a8bg","birthday":"ConsentHeader_birthday__1vLcg","skeleton":"ConsentHeader_skeleton__3UdX_"};